var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"syncCalendar"},[_vm._v(" You can integrate   "),_c('app-button',{attrs:{"title":_vm.profileInfo.google_calendar_synced ? 'Google Calendar Integrated' : 'Google Calendar',"disabled":_vm.profileInfo.google_calendar_synced,"onClick":_vm.googleAuth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }